// Models the Thunder V2/Responses/MediaDetailsResponse.cs model

let Type = require('./Type');
let Covers = require('./Covers');
let Link = require('./Link');
let Language = require('./Language');
let Imprint = require('./Imprint');
let MaturityLevel = require('./MaturityLevel');
let NaughtyScore = require('./NaughtyScore');
let Publisher = require('./Publisher');
let Level = require('./Level');
let Creator = require('./Creator');
let Subject = require('./Subject');
let Constraints = require('./Constraints');
let ContentRatings = require('./ContentRatings');
let ReviewCounts = require('./ReviewCounts');

module.exports = class MediaDetail {
    constructor() {
        this.id = 0;
        this.reserveId = '';
        this.title = '';
        this.subtitle = '';

        this.isAvailable = false;
        this.isPreReleaseTitle = false;
        this.isFastlane = false;
        this.isOwned = false;
        this.isHoldable = false;
        this.isBundledChild = false;

        /** @type {Type} */
        this.type = null;
        /** @type {Publisher} */
        this.publisher = null;
        /** @type {Imprint} */
        this.imprint = null;

        this.firstCreatorId = 0;
        this.firstCreatorName = '';

        /** @type {Creator[]} */
        this.creators = [];
        /** @type {Subject[]} */
        this.subjects = [];
        /** @type {Format[]} */
        this.formats = [];
        /** @type {Language[]} */
        this.languages = [];
        /** @type {string[]} */
        this.bisacCodes = [];
        /** @type {Level[]} */
        this.levels = [];

        /** @type {ContentRatings} */
        this.ratings = null;
        /** @type {ReviewCounts} */
        this.reviewCounts = null;
        /** @type {Constraints} */
        this.constraints = null;

        /** @type {Link} */
        this.sample = null;

        /** @type {Covers} */
        this.covers = null;

        this.description = '';

        this.estimatedReleaseDate = '';

        Object.assign(this, ...arguments);
    }
};
